var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6069",
    "data-name": "Group 6069",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#323338",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8563",
    "data-name": "Path 8563",
    d: "M4,7H9V4a2.006,2.006,0,0,1,2-2h2a2.006,2.006,0,0,1,2,2V7h5a2.006,2.006,0,0,1,2,2V20a2.006,2.006,0,0,1-2,2H4a2.006,2.006,0,0,1-2-2V9A2.006,2.006,0,0,1,4,7Zm11,5a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,15,12Zm-3,6h6v-.43a1.516,1.516,0,0,0-.92-1.39,5.246,5.246,0,0,0-4.16,0A1.522,1.522,0,0,0,12,17.57ZM11,9h2V4H11ZM6.75,16.5h2.5a.755.755,0,0,0,.75-.75h0A.755.755,0,0,0,9.25,15H6.75a.755.755,0,0,0-.75.75H6A.755.755,0,0,0,6.75,16.5Zm0-3h2.5a.755.755,0,0,0,.75-.75h0A.755.755,0,0,0,9.25,12H6.75a.755.755,0,0,0-.75.75H6A.755.755,0,0,0,6.75,13.5Z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastName);
export default __webpack_public_path__ + "static/media/last_name.02ff055307c487403b402cc81a7eb4be.svg";
export { ForwardRef as ReactComponent };